import React, { useEffect, useRef } from 'react';
import { instance } from '../../api/axiosInstance';
import { useLocation, useNavigate } from 'react-router-dom';
import Cookies from 'js-cookie';
import { NavLink } from 'react-router-dom';
import { FcOk } from 'react-icons/fc';

const SuccessPage: React.FC = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const params = new URLSearchParams(location.search);
  const orderId = params.get('orderId');
  const paymentKey = params.get('paymentKey');
  const amount = params.get('amount');
  const productIdsString = params.get('productIds');

  const hasVerified = useRef(false); // Prevents duplicate execution

  // Initialize productIds as an empty array
  let productIds: string[] = [];

  // Check if productIdsString is not null and split it to create an array
  if (productIdsString) {
    productIds = productIdsString.split(',').map(id => id.trim());
  }

  // Log the values to the console
  console.log('orderId:', orderId);
  console.log('paymentKey:', paymentKey);
  console.log('amount:', amount);
  console.log('productIds:', productIds); // This should show the correct product IDs

  useEffect(() => {
    if (hasVerified.current) return; // Prevent duplicate execution
    hasVerified.current = true;

    const verifyPayment = async () => {
      // Check for necessary parameters and valid productIds array
      if (!orderId || !paymentKey || !amount || !Array.isArray(productIds) || productIds.length === 0) {
        console.error('Missing values');
        navigate('/fail'); // Redirect if any required parameter is missing
        return;
      }

      const accessToken = Cookies.get('access_token');
      if (!accessToken) {
        console.error('Authentication token is missing.');
        navigate('/fail');
        return;
      }

      try {
        const response = await instance.post(
          '/auth/confirm',
          {
            orderId,
            paymentKey,
            amount,
            productIds, // Sending an array of product IDs
          },
          {
            headers: {
              Authorization: `Bearer ${accessToken}`,
            },
          }
        );

        if (response.status === 200) {
          console.log(response.data);
        } else {
          console.log(response.data);
        }
      } catch (error) {
        console.error('Payment verification failed:', error);
      }
    };

    verifyPayment();
  }, [orderId, paymentKey, amount, productIds, navigate]);

  return (
    <div className="flex items-center flex-col justify-center min-h-screen bg-white">
      <div className="mt-[50px]">
        <NavLink to="/">
          <img src={`${process.env.PUBLIC_URL}/logo/logo.png`} alt="Creator Store" className="h-auto object-cover" />
        </NavLink>
      </div>
      <FcOk className="text-6xl mt-[30px] mb-[20px]" />
      <h1 className="font-semibold text-[#333333] text-2xl text-center mb-4">
        주문 결제가 완료되었습니다.
        <br />
        이용해주셔서 감사합니다.
      </h1>
      <p className="text-[#333333] text-sm mt-2">
        주문 번호: <strong>{orderId}</strong>
      </p>
      <p className="text-[#333333] text-sm mt-2">
        제품 번호: <strong>{productIds.length > 0 ? productIds.join(', ') : '정보 없음'}</strong>
      </p>
      <button type="button" className="mt-[70px] max-w-[400px] w-full bg-MainColor shadow-md rounded-full h-[50px] text-white transition duration-300 ease-in-out text-lg" onClick={() => navigate(`/products/details/${productIds}`)}>
        확인
      </button>
    </div>
  );
};

export default SuccessPage;
